module.exports = __webpack_public_path__ + "static/media/graph.e2d2bf8d.png";